import React from 'react'
import {Breadcrumb, Button, Layout} from "antd";
import useBreakpoint from "antd/es/grid/hooks/useBreakpoint";

export default (props) => {
    const {xs} = useBreakpoint();

    // if(xs) {
    //     return <>
    //
    //     </>
    // }

    return (
       <Breadcrumb
        >
           {props.children}
       </Breadcrumb>
    )
}